// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Master Business State
// -------------------------------
export interface MasterBusinessState extends EntityState<any> {
  common?: any;

  stressProfileList: Array<any>;
  stressProfileDetails: any;
  stressProfileLookup: Array<any>;
  stressProfileAllList: Array<any>;

  trainingLicenseList: Array<any>;
  trainingLicenseDetails: any;
  trainingLicenseAllList: Array<any>;

  publicHolidayAllList: Array<any>;
  publicHolidayList: Array<any>;
  publichHolidayDetails: any;

  leaveList: Array<any>;
  leaveDetails: any;
  leaveAllList: Array<any>;

  employeeRoleLookup: Array<any>;
  masterLeaveLookup: Array<any>;
}

// -------------------------------
//  Master Business Adapter
// -------------------------------
export const businessAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Master Business Initial State
// -------------------------------
export const initialState: MasterBusinessState = businessAdapter.getInitialState(
  {
    common: null,

    stressProfileList: [],
    stressProfileDetails: {},
    stressProfileAllList: [],

    trainingLicenseList: [],
    trainingLicenseDetails: {},
    trainingLicenseAllList: [],

    publicHolidayAllList: [],
    publicHolidayList: [],
    publichHolidayDetails: {},

    leaveList: [],
    leaveDetails: {},
    leaveAllList: [],

    stressProfileLookup: [],

    employeeRoleLookup: [],
    masterLeaveLookup: [],
  },
);
